import { HTTPValidationError } from './HttpValidationError';
export class ApiResponse {
  status?: number;
  error?: HTTPValidationError;
  message?: string;
  data: any;
}
